/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Waiting_GatesInputs */

const en_nav_waiting_gates = /** @type {(inputs: Nav_Waiting_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting approvals`)
};

/**
* | output |
* | --- |
* | "Waiting approvals" |
*
* @param {Nav_Waiting_GatesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_waiting_gates = /** @type {((inputs?: Nav_Waiting_GatesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Waiting_GatesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_waiting_gates(inputs)
});